import {Component, TemplateRef} from "@angular/core";
import {FormControl, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {ModalContext} from "n-framework/n-modal";
import {BehaviorSubject, Observable} from "rxjs";

const defaultRemoveButtonText = "УДАЛИТЬ";
const defaultSubmitButtonText = "СОХРАНИТЬ";
const defaultCancelButtonText = "ОТМЕНИТЬ";
const defaultCreateButtonText = "СОЗДАТЬ";

@Component({
  selector: "n-prompt-modal",
  templateUrl: "./n-prompt-modal.html",
  styleUrls: [
    "./n-prompt-modal.css",
  ],
})
export class NPromptModalComponent {
  creating: boolean;

  type: PromptModalType;
  title: string;
  text: string;
  acceptButtonText: string;
  cancelButtonText: string;

  hasInput: boolean;
  inputPlaceholder: string;
  inputRequired: boolean;
  inputValue: string;
  templateRef?: TemplateRef<any>;
  promptInvalid$?: Observable<boolean>;

  primaryButtonClass: string;

  form: FormGroup;

  constructor(private modalCtx: ModalContext<PromptModalOptions, any>) {
    const modalData = this.modalCtx.modalData;
    this.type = modalData.type;
    this.title = modalData.title;
    this.text = modalData.text;

    if (modalData.acceptButtonText) {
      this.acceptButtonText = modalData.acceptButtonText;
    } else {
      // default values
      switch (this.type) {
        case PromptModalType.ACCEPT:
          this.acceptButtonText = defaultSubmitButtonText;
          break;
        case PromptModalType.REMOVE:
          this.acceptButtonText = defaultRemoveButtonText;
          break;
        case PromptModalType.CREATE:
          this.acceptButtonText = defaultCreateButtonText;
          break;
        default:
          this.acceptButtonText = defaultSubmitButtonText;
      }
    }
    this.cancelButtonText = modalData.cancelButtonText || defaultCancelButtonText;

    this.templateRef = modalData.templateRef;

    this.hasInput = modalData.inputField;
    this.inputValue = modalData.inputFieldDefaultValue;

    this.inputRequired = modalData.inputFieldIsRequired;
    this.inputPlaceholder = modalData.inputFieldPlaceholder || "";


    switch (this.type) {
      case PromptModalType.REMOVE:
        this.primaryButtonClass = "negative";
        break;
      default:
        this.primaryButtonClass = "prime";
        break;
    }


    this.form = new FormGroup({
      promptInput: new FormControl()
    });

    if (this.hasInput) {
      this.form.controls["promptInput"].setValue(this.inputValue);

      if (modalData.inputFieldValidators || this.inputRequired) {
        const validators = Array.isArray(modalData.inputFieldValidators)
          ? [...modalData.inputFieldValidators]
          : modalData.inputFieldValidators
            ? [modalData.inputFieldValidators]
            : [];

        if (this.inputRequired) {
          validators.push(Validators.required);
        }

        this.form.controls["promptInput"].setValidators(validators);
      }
    }

    this.promptInvalid$ = modalData.promptInvalid$;
  }


  submit() {
    if (this.hasInput) {
      this.modalCtx.done(this.form.controls["promptInput"].value || "");
    } else {
      this.modalCtx.done(true);
    }
  }

  close() {
    this.modalCtx.done(undefined);
  }
}

export enum PromptModalType {
  ACCEPT = 1,
  REMOVE,
  CREATE
}

export interface PromptModalOptions {
  type?: PromptModalType;
  title: string;
  text?: string;
  acceptButtonText?: string;
  cancelButtonText?: string;
  templateRef?: TemplateRef<any>;

  inputField?: boolean;
  inputFieldDefaultValue?: string;
  inputFieldIsRequired?: boolean;
  inputFieldPlaceholder?: string;
  inputFieldValidators?: ValidatorFn | ValidatorFn[];

  promptInvalid$?: BehaviorSubject<boolean>;
}

